import { render, staticRenderFns } from "./RelationshipsNotes.vue?vue&type=template&id=0a8990bc&"
import script from "./RelationshipsNotes.vue?vue&type=script&lang=js&"
export * from "./RelationshipsNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports